import React, { useState } from 'react';
import { 
  X, 
  Copy, 
  Mail, 
  Link as LinkIcon, 
  Share2,
  Check,
  Download 
} from 'lucide-react';

export const ShareModal = ({ 
  isOpen, 
  onClose, 
  videoUrl, 
  routineTitle,
  onDownload 
}) => {
  const [copied, setCopied] = useState(false);

  if (!isOpen) return null;

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(videoUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const shareOptions = [
    {
      icon: Mail,
      label: 'Email',
      onClick: () => window.location.href = `mailto:?subject=Check out this routine&body=${videoUrl}`
    },
    {
      icon: Download,
      label: 'Download',
      onClick: () => onDownload?.(videoUrl, routineTitle)
    }
  ];

  return (
    <>
      <div 
        className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50"
        onClick={onClose}
      />
      <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto p-4">
        <div className="relative w-full max-w-md bg-base-100 rounded-lg shadow-xl">
          {/* Header */}
          <div className="flex items-center justify-between p-4 border-b border-base-200">
            <div className="flex items-center gap-2">
              <Share2 className="w-5 h-5 text-primary" />
              <h3 className="text-lg font-semibold text-base-content">
                Share Critique
              </h3>
            </div>
            <button
              onClick={onClose}
              className="btn btn-ghost btn-sm btn-circle"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* Content */}
          <div className="p-4">
            {/* Link Sharing */}
            <div className="mb-6">
              <label className="text-sm font-medium text-base-content">
                Video Link
              </label>
              <div className="mt-2 flex gap-2">
                <div className="flex-1 flex items-center gap-2 px-3 py-2 bg-base-200 rounded-lg">
                  <LinkIcon className="w-4 h-4 text-base-content/40" />
                  <input
                    type="text"
                    value={videoUrl}
                    readOnly
                    className="flex-1 bg-transparent border-none focus:outline-none text-sm text-base-content"
                  />
                </div>
                <button
                  onClick={handleCopyLink}
                  className="btn btn-primary btn-sm gap-2"
                >
                  {copied ? (
                    <>
                      <Check className="w-4 h-4" />
                      Copied
                    </>
                  ) : (
                    <>
                      <Copy className="w-4 h-4" />
                      Copy
                    </>
                  )}
                </button>
              </div>
            </div>

            {/* Share Options */}
            <div className="grid grid-cols-2 gap-3">
              {shareOptions.map((option, index) => {
                const Icon = option.icon;
                return (
                  <button
                    key={index}
                    onClick={option.onClick}
                    className="flex flex-col items-center gap-2 p-4 rounded-lg bg-base-200 hover:bg-base-300 transition-colors"
                  >
                    <Icon className="w-6 h-6 text-primary" />
                    <span className="text-sm font-medium text-base-content">
                      {option.label}
                    </span>
                  </button>
                );
              })}
            </div>

            {/* Additional Info */}
            <p className="mt-4 text-xs text-base-content/60 text-center">
              Only users with access to this critique can view it
            </p>
          </div>
        </div>
      </div>
    </>
  );
};